<template>
    <div class="player" :class="{lastStand: isLastStand, notLastStand: !isLastStand}">
        <div id="top-bar">
            <div :title="description" class="name noselect" :class="{dead:player.isDead, 'has-text-light':!player.isDead}" @click="modalVisible = true">{{ player.characterName }}</div>
            <div ref="hopeButton" v-if="!player.isDead" id="hope" class="side hope noselect" :class="{hasHope : player.hasHope}"  @click="player.hasHope = !player.hasHope"><p><strong>H</strong></p></div>
        </div>
        <div id="stackContainer" @click="dead">
            <button :disabled="this.nextCard" v-show="!stackEmpty" class="stack stackFull" :class="{ transitionToNextCard: nextCard }" @click="burnCard">
                <div class="stack-label">
                     <p><strong>{{player.stackOrder[player.stackIndex]}}</strong></p>
                <hr class="solid">
                <p v-if="player.stackOrder[player.stackIndex] === 'Virtue'">{{ player.virtue }}</p>
                <p v-if="player.stackOrder[player.stackIndex] === 'Vice'">{{ player.vice }}</p>
                <p v-if="player.stackOrder[player.stackIndex] === 'Hope'">{{ player.hope }}</p>
                </div>
               
            </button>
            <transition name = "fade">
              <button v-if="stackEmpty && hasBrink" class="stack brink"  @click="burnBrink">
                  <div v-if="hasBrink" class="stack-label">
                      <p><strong class="has-text-light">Brink</strong></p>
                                      <hr class="solid">

                  <p  ><strong class="has-text-white"> {{ player.brink }} </strong></p>
                  </div>
              </button>
            </transition>
        </div>
        <div v-if="modalVisible === true" class="modal is-active">

  <div class="modal-background"/>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title has-text-light">Character Settings</p>
      <button class="delete" aria-label="close" @click="modalVisible = false"></button>
    </header>
    <section class="modal-card-body">
      <form class="form-horizontal" >
<fieldset>


<!-- Text input-->
<div class="field">
  <label class="label" for="player-name">Name <span class="tooltip-element noselect" title="Your character's name.  max 20 characters">✦</span></label>
  <div class="control">
    <input id="name" name="player-name" type="text" class="input " placeholder="Name..." :value="player.characterName" @input="event => player.characterName = event.target.value">
  </div>
</div>

<!-- Textarea -->
<div class="field">
  <label class="label" for="description">Character Description <span class="tooltip-element noselect" title="Describe who you are, what you look like and why you are here.">✦</span></label>
  <div class="control">                     
    <textarea class="textarea" id="description" name="description" :value="player.description" @input="event => player.description = event.target.value"></textarea>

  </div>
</div>

<!-- Text input-->
<div class="field">
  <label class="label" for="Virtue">Virtue <span class="tooltip-element noselect" title="A positive aspect of your character that you will use in a time of need.">✦</span></label>
  <div class="control">
    <input id="Virtue" name="Virtue" type="text" class="input " placeholder="Virtue..." :value="player.virtue" @input="event => player.virtue = event.target.value">
    <p class="help"></p>
  </div>
</div>

<!-- Text input-->
<div class="field">
  <label class="label" for="vice">Vice <span class="tooltip-element noselect" title="A negative aspect of your character you will fall to when in trouble.">✦</span></label>
  <div class="control">
    <input id="vice" name="vice" type="text" class="input " placeholder="Vice..." :value="player.vice" @input="event => player.vice = event.target.value">
    <p class="help">A harmful aspect of your character.</p>
  </div>
</div>

<!-- Text input-->
<div class="field">
  <label class="label" for="Hope">Hope <span class="tooltip-element noselect" title="A moment where your character may find a moment of reprieve. This moment should be able to succeed or fail.">✦</span></label>
  <div class="control">
    <input id="Hope" name="Hope" type="text" placeholder="I will find hope when ..." class="input " :value="player.hope" @input="event => player.hope = event.target.value">
  </div>
</div>

<!-- Text input-->
<div class="field">
  <label class="label" for="brink">Brink <span class="tooltip-element noselect" title="The depths to which your character will fall to in their darkest moments. This will be the last card you will burn.">✦</span></label>
  <div class="control">
    <input id="brink" name="brink" type="text" placeholder="I have seen you..." class="input " :value="player.brink" @input="event => player.brink = event.target.value">
  </div>
</div>

<!-- Multiple Radios -->
<div class="field">
  <label class="label" for="stack-top">Top Card <span class="tooltip-element noselect" title="The first card you will burn.">✦</span></label>
  <div class="control">
    <label class="radio" for="stack-top-0">
      <input type="radio" name="stack-top" id="stack-top-0" value="Virtue" v-model="player.stackOrder[0]">
      Virtue
    </label>
    <label class="radio" for="stack-top-1">
      <input type="radio" name="stack-top" id="stack-top-1" value="Vice" v-model="player.stackOrder[0]">
      Vice
    </label>
    <label class="radio" for="stack-top-2">
      <input type="radio" name="stack-top" id="stack-top-2" value="Hope" v-model="player.stackOrder[0]">
      Hope
    </label>
  </div>
</div>

<!-- Multiple Radios -->
<div class="field">
  <label class="label" for="stack-middle">Middle Card <span class="tooltip-element noselect" title="The second card you will burn.">✦</span></label>
  <div class="control">
    <label class="radio" for="stack-middle-0">
      <input :disabled="player.stackOrder[0] === 'Virtue'" type="radio" name="stack-middle" id="stack-middle-0" value="Virtue" v-model="player.stackOrder[1]">
      Virtue
    </label>
    <label class="radio" for="stack-middle-1">
      <input :disabled="player.stackOrder[0] === 'Vice'" type="radio" name="stack-middle" id="stack-middle-1"  value="Vice" v-model="player.stackOrder[1]">
      Vice
    </label>
    <label class="radio" for="stack-middle-2">
      <input :disabled="player.stackOrder[0] === 'Hope'" type="radio" name="stack-middle" id="stack-middle-2" value="Hope" v-model="player.stackOrder[1]">
      Hope
    </label>
  </div>
</div>

<!-- Multiple Radios -->
<div class="field">
  <label class="label" for="stack-bottom">Bottom Card <span class="tooltip-element noselect" title="The third card you will burn.">✦</span></label>
  <div class="control">
    <label class="radio" for="stack-bottom-0">
      <input :disabled="player.stackOrder[0] === 'Virtue' || player.stackOrder[1] === 'Virtue'" type="radio" name="stack-bottom" id="stack-bottom-0" value="Virtue" v-model="player.stackOrder[2]">
      Virtue
    </label>
    <label  class="radio" for="stack-bottom-1">
      <input  :disabled="player.stackOrder[0] === 'Vice' || player.stackOrder[1] === 'Vice'" type="radio" name="stack-bottom" id="stack-bottom-1" value="Vice" v-model="player.stackOrder[2]">
      Vice
    </label>
    <label  class="radio" for="stack-bottom-2">
      <input :disabled="player.stackOrder[0] === 'Hope' || player.stackOrder[1] === 'Hope'" type="radio" name="stack-bottom" id="stack-bottom-2" value="Hope" v-model="player.stackOrder[2]">
      Hope
    </label>
  </div>
</div>

</fieldset>
</form>

    </section>
    <footer class="modal-card-foot">
      <button class="button is-dark " @click="saveDetails">Save</button>
       <button class="button is-warning " @click="clearDetails">Clear</button>
       <button class="button is-light " @click="resetStack">Reset Player State</button>
       <button class="button is-danger " @click="deletePlayer">Delete</button>

    </footer>
  </div>
</div>
    </div>
</template>

<script>
import { storeToRefs } from 'pinia';
import { usePlayerStore } from '../store/usePlayerStore'
export default {
  name: 'PlayerBanner',
  props:{
    isLastStand: Boolean,
    playerData: Object,
    id: Number,
  },
  setup(props){
    const playerStore = usePlayerStore();
    const {hopeAvailable, players } = storeToRefs(playerStore);
    const player = players.value[props.id];
    return{
      player,
      hopeAvailable,
      playerStore
    }
  },
  data () {
      return {
          
          stackEmpty: false,
          hasBrink: true,
          modalVisible: false,
          nextCard: false,
          isDead: false,
          canDie: false,
 
        }
  },
  methods: {
      burnCard() {
          
          this.nextCard = true;
          setTimeout(() => {
          this.player.stackIndex += 1
          if(this.player.stackIndex > 2) this.stackEmpty = true
          this.nextCard = false;
          }, 1000)
           
          
        
      },
      burnBrink() {
          this.hasBrink = false;
      },
      saveDetails() {
       this.modalVisible = false;
      },
      clearDetails(){
          if(!window.confirm("Are you sure you want to clear all fields?")) return;
          [this.player.characterName, this.player.description,this.player.virtue,this.player.vice,this.player.hope,this.player.brink] = "";
          
      },
      resetStack() {
          this.hasBrink = true;
          this.player.stackIndex = 0;
          this.player.hasHope = false;
          this.stackEmpty = false;
          this.canDie = false;
      },
      dead(){
        if(this.stackEmpty && !this.hasBrink && !this.canDie) return this.canDie = true;
        else if(this.canDie){
          this.player.isDead = true;
          console.log('dead')
        }
      },
      deletePlayer(){
        if(!window.confirm("Are you sure you want to delete " + this.player.characterName + "?")) return;
        this.modalVisible = false;
        this.$parent.deletePlayer(this.id);
      }
  }
}
</script>

<style scoped>
    @font-face {
    font-family: "Caveat";
    src: local("Caveat"),
    url(../assets/fonts/caveat.regular.ttf) format("truetype");
    }
   @font-face {
  font-family: "SansCulottes";
  src: local("SansCulottes"),
  url(../assets/fonts/SansCulottes.ttf) format("truetype");
}
    .player {
        display: flex;
        flex-direction: column;
        width: 200px;
        height: 150px;
        background-color: rgb(7, 7, 7);    
       border-radius: 10px;
    }
    #top-bar {
            display: flex;
            height: 20%;
    }
     .name {
        flex: 4;
        padding: 5px;
        overflow: hidden;
        text-overflow: ellipsis;
        line-height: 1em;
        border-bottom: 1px solid rgb(32,32,32);
    }
    .name:hover {
      cursor: pointer;
    }
    .dead {
      color: maroon;
      opacity: 0.6;
    }
    .side {
        flex:1;
        border-width: 0;
        border-bottom-width: 1px;
        border-left-width: 1px;
        border-color: rgb(32, 32, 32);
        box-sizing: border-box;
        border-style: solid;
        justify-content: center;
        align-items: center;
        display: flex;
    }
    #hope {
        border-top-right-radius: 10px;
        -webkit-transition: all 0.5s linear;
        -moz-transition: all 0.5s linear;
        -o-transition: all 0.5s linear;
        transition: all 0.5s linear;
         cursor: pointer;
    }
    #hope.hasHope {
        background-color: rgb(212, 212, 212);
        color: rgb(7,7,7);
    }
    #stackContainer {
        height: 80%;
        display: flex;
        flex-direction: column;
        background-image: url(../assets/Candle.jpg);
        background-position: center;
        background-size: contain;
        border-radius: 10px;
    }
    .stack {
        display: flex;
        justify-content: center;
        align-items: center;
        flex:1;
        border-width: 0px;
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
        font-family: "Caveat";
        font-size: 1.25em;
        opacity: 100%;
        transition: opacity 1s;
        background: linear-gradient(#1f1f1f, 20%, #fcefd2);
    }
    
    .brink {
        background: linear-gradient(rgb(7,7,7), maroon);
        color: white;
    }
      hr.solid {
      border-top: 2px solid rgb(7, 7, 7);
      background-color: rgba(0,0,0,0);
      border-radius: 20px;
      opacity: 0.5;
      margin-top: 8px;
      margin-bottom: 8px;
      max-width: 90%;
    }
    .stack.transitionToNextCard {
    opacity: 0%;
    }
    
    .modal-card-head,.modal-card-foot {
        background-color: rgb(32,32,32);
        color: white;
    }
    .modal-card-body {
         background-color: rgb(18,18,18);
         font-family: "Caveat";
    }
    
    label {
        color: white;
         font-size: 13pt;
         font-family: "SansCulottes", "Caveat", sans-serif;
    }
    input, textarea{
        background-color: rgb(53,53,53);
        border-color: rgb(32,32,32);  
        color: white;   
    }
    input:hover,textarea:hover{
        border-color: rgb(78,78,78);
    }
    input:focus,textarea:focus{
        border-color: rgb(78,78,78);
        box-shadow:0px 0px 2px rgb(221, 168, 23);
    }
    .help {
        font-size: 18px;
    }
    .radio {
        font-family: "Caveat", sans-serif;
    }
    .radio:hover {
        color: rgb(221, 168, 23)
    }
    
    [type="radio"]:checked+label:after {
        background-color: rgb(221, 168, 23);
    }
    
    ::placeholder {
        color:white;
        font-family: "SansCulottes";
        font-style: italic;
        opacity: 0.3;
    }
    .fade-leave-active, .fade-enter-active {
        transition: opacity 400ms ease-out;
    }
    .fade-enter-from, .fade-leave-to {
        opacity: 1%;
    }
    .tooltip-element{
      font-size: 10pt;
      margin-left: 3pt;
      color: rgba(255,255,255,0.3)
    }
 
</style>